import styled from '~/app/components/styled'
import { HideScrollBar } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    height: 100vh;
  }
`

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.gray100};
  overflow: auto;
  flex: 1;
  display: flex;
  justify-content: center;

  ${HideScrollBar}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: calc(100vh - 4.8rem);
  height: 100%;
  max-width: ${({ theme }) => theme.unit.PC_WIDTH}px;
  background: ${({ theme }) => theme.color.gray50};
  overflow-x: hidden;

  ${HideScrollBar}
`

export const BottomNotice = styled.footer`
  padding: 2rem;
  flex: 0 0 auto;
  ${Typography('body2').regular};

  & .first {
    ${Typography('body2.multiline').regular};
    color: ${({ theme }) => theme.color.gray600};
    padding-bottom: 2rem;
  }

  & .second {
    color: ${({ theme }) => theme.color.gray600};
    padding-bottom: 8.4rem;
  }
`
